'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _Utility = require('../../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _TabContainer = require('../generic/TabContainer');

var _TabContainer2 = _interopRequireDefault(_TabContainer);

var _TabPane = require('../generic/TabPane');

var _TabPane2 = _interopRequireDefault(_TabPane);

var _SimpleButton = require('../generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _Actions = require('../../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _CartStore = require('../../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _Constants = require('../Constants');

var Constants = _interopRequireWildcard(_Constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PICKUP = Constants.PICKUP;
var CURBSIDEPICKUP = Constants.CURBSIDEPICKUP;
var DINEIN = Constants.DINEIN;
var DELIVERY = Constants.DELIVERY;

var OrderScheduleScreen = function (_React$Component) {
    _inherits(OrderScheduleScreen, _React$Component);

    function OrderScheduleScreen(props) {
        _classCallCheck(this, OrderScheduleScreen);

        var _this = _possibleConstructorReturn(this, (OrderScheduleScreen.__proto__ || Object.getPrototypeOf(OrderScheduleScreen)).call(this, props));

        _this.isAsapOrder = function () {
            return _this.state.isAsapOrder ? true : false;
        };

        _this.isValid = function (openHours, current) {

            var day = current.getDay();
            var shortDayStr = Utils.getDayShort(day).toUpperCase();

            return openHours[shortDayStr] && openHours[shortDayStr].toUpperCase() != 'CLOSED';
        };

        _this.getScheduledAheadDays = function () {

            var schAheadDays = 5;
            var businessDetail = _MainStore2.default.getBusinessDetail();
            if (businessDetail && businessDetail.bizConfig) {
                var bizConfig = businessDetail.bizConfig;

                // Schedule ahead days will work only for current day if the ahead day set 0
                if (bizConfig.schAheadDays == 0) {
                    return 0;
                }

                if (!Utils.isEmpty(bizConfig.schAheadDays)) {
                    schAheadDays = bizConfig.schAheadDays;
                }
            }

            return schAheadDays;
        };

        _this.getScheduledIntervalMins = function () {

            var schIntervalMins = 15;
            var businessDetail = _MainStore2.default.getBusinessDetail();

            if (businessDetail && businessDetail.bizConfig) {
                var bizConfig = businessDetail.bizConfig;

                if (!Utils.isEmpty(bizConfig.schIntervalMins)) {
                    schIntervalMins = bizConfig.schIntervalMins;
                }
            }

            return schIntervalMins;
        };

        _this.getScheduledOffsetMins = function () {

            var offset = 15;
            var businessDetail = _MainStore2.default.getBusinessDetail();
            var orderType = _this.state.orderType;

            if (businessDetail && businessDetail.bizConfig) {
                var bizConfig = businessDetail.bizConfig;

                if (orderType == "PickUp") {
                    offset = bizConfig.schPickUpOffsetMins ? bizConfig.schPickUpOffsetMins : 15;
                }

                if (orderType == "Delivery") {
                    offset = bizConfig.schDeliveryOffsetMins ? bizConfig.schDeliveryOffsetMins : 40;
                }
            }

            return offset;
        };

        _this.onScheduledTabClick = function () {
            var openHours = _CartStore2.default.getOnlineOrderingHours(_this.state.orderType);

            var futureDates = _this.state.futureDates;
            var orderFirstDate = new Date(futureDates[0]);
            var hoursRange = _this.generateHoursRange(orderFirstDate);

            var timeStr = hoursRange[0];
            orderFirstDate = Utils.parseTime(timeStr, orderFirstDate);

            _this.setState({
                value12: orderFirstDate,
                selectedTime: timeStr,
                selectedDateIndex: 0,
                selectedDateTimings: Utils.getOpeningHoursOfGivenDate(openHours, orderFirstDate),
                isScheduleOrderTime: !_this.props.disableSetButton ? true : false
            }, function () {
                _this.updateASAPScheduleTab(false);
                _this.props.updateScheduledDate(_this.state.value12);
            });
        };

        _this.generateFutureDates = function () {

            var selectedDateIndex = _this.state.selectedDateIndex;
            var futureDatesArray = _this.state.futureDates;

            return futureDatesArray.map(function (dateStr, i) {

                var style = i == selectedDateIndex ? "selected" : "";
                return _react2.default.createElement(
                    'option',
                    {
                        className: 'future-date ' + style,
                        key: 'fd-' + i,
                        value: dateStr.toDateString()
                    },
                    Utils.getDayShort(dateStr.getDay()),
                    ', ',
                    Utils.getMonthNameShort(dateStr.getMonth()),
                    ' ',
                    dateStr.getDate()
                );
            });
        };

        _this.generateHoursRange = function (selectedDate) {

            var activeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();

            /*
            *    activeLocationOpenHours should return the openHours of  the location
            * */

            var openHours = _CartStore2.default.getOnlineOrderingHours(_this.state.orderType);

            /*
            *   openHours is the orderType openHours
            * */

            if (_this.isValid(activeLocationOpenHours, selectedDate) && _this.isValid(openHours, selectedDate)) {

                var scheduleIntervalMins = _this.getScheduledIntervalMins();
                var offsetMins = _this.getScheduledOffsetMins();
                var selectedDateTimings = Utils.getOpeningHoursOfGivenDate(openHours, selectedDate);

                // get date time based on the location
                var dateTime = _MainStore2.default.getCurrentDateTime();

                var options = [];

                var changeableDate = selectedDate ? new Date(selectedDate.toDateString()) : dateTime;

                var individualHours = Utils.getIndividualHours(selectedDateTimings, changeableDate);

                var hoursLen = individualHours.length;
                var idx = 0;

                while (idx < hoursLen) {
                    var date1 = individualHours[idx][0];
                    var date2 = individualHours[idx][1];

                    var i = 1;

                    var currentDate = _MainStore2.default.getCurrentDateTime();

                    var nowDateWithOffset = _MainStore2.default.getCurrentDateTime();
                    nowDateWithOffset.setMinutes(nowDateWithOffset.getMinutes() + offsetMins);

                    while (date1 <= date2) {

                        if (date1 >= currentDate && date1 > nowDateWithOffset) {
                            options.push(Utils.dateToHours(date1));
                        }

                        date1.setMinutes(date1.getMinutes() + scheduleIntervalMins);
                        i++;
                    }
                    idx++;
                }

                return options;
            }

            return null;
        };

        _this.generateFutureTime = function () {

            if (_this.state.value12) {
                var hoursRange = _this.generateHoursRange(_this.state.value12);

                return hoursRange.map(function (hoursStr, i) {
                    return _react2.default.createElement(
                        'option',
                        {
                            className: 'future-date',
                            key: 'fd-' + i,
                            value: hoursStr
                        },
                        hoursStr
                    );
                });
            } else {
                var futureDates = _this.state.futureDates;
                var orderFirstDate = new Date(futureDates[0]);
                var _hoursRange = _this.generateHoursRange(orderFirstDate);

                return _hoursRange.map(function (hoursStr, i) {
                    return _react2.default.createElement(
                        'option',
                        {
                            className: 'future-date',
                            key: 'fd-' + i,
                            value: hoursStr
                        },
                        hoursStr
                    );
                });
            }
        };

        _this.handleSelectedDateTimeChange = function (e) {

            var date = new Date(_this.state.value12);
            var timeStr = e.target.value;

            date = Utils.parseTime(timeStr, date);

            _this.setState({
                selectedTime: timeStr,
                value12: date
            }, function () {
                _this.props.updateScheduledDate(_this.state.value12);
            });
        };

        _this.resetScheduledDate = function () {
            _this.setState({
                isAsapOrder: true,
                selectedTime: "",
                value12: null
            });
        };

        _this.onAsapTabClick = function () {

            _this.setState({
                selectedTime: "",
                value12: null
            }, function () {
                _this.updateASAPScheduleTab(true);
                _this.props.updateScheduledDate(_this.state.value12);
            });
        };

        _this.handleSelectedDateChange = function (e) {
            var date = new Date(e.target.value);
            var openHours = _this.props.locationDetail.openHours;

            var hoursRange = _this.generateHoursRange(date);
            var timeStr = hoursRange[0];

            date = Utils.parseTime(timeStr, date);

            _this.setState({
                value12: date,
                selectedTime: timeStr,
                selectedDateIndex: e.target.selectedIndex,
                selectedDateTimings: Utils.getOpeningHoursOfGivenDate(openHours, date)
            }, function () {
                _this.props.updateScheduledDate(_this.state.value12);
            });
        };

        _this.hideScheduleTimeComp = function () {
            _this.setState({
                isScheduleOrderTime: false
            });
        };

        _this.showScheduleTimeComp = function () {
            _this.setState({
                isScheduleOrderTime: true
            });
        };

        _this.state = {
            futureDates: [],
            value12: "",
            selectedDateIndex: 0,
            isAsapOrder: true,
            selectedTime: "",
            selectedDateTimings: "",
            isScheduleOrderTime: false,
            scheduledDateTime: "",
            orderType: "",
            showScheduleTimeError: false,
            isLoading: false
        };
        return _this;
    }

    _createClass(OrderScheduleScreen, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            this.setState({
                orderType: this.props.orderType,
                isAsapOrder: true

            }, function () {
                _this2.setOpenAvailableFutureDate();
            });
        }
    }, {
        key: 'UNSAFE_componentWillReceiveProps',
        value: function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this3 = this;

            var scheduledDate = nextProps.scheduledDate;
            var scheduleDateTime = _ScheduleScreenStore2.default.getScheduledDate();

            if (nextProps.orderType != this.state.orderType) {
                this.setState({
                    orderType: nextProps.orderType
                }, function () {
                    _this3.setOpenAvailableFutureDate();
                });

                if (Utils.isEmpty(scheduleDateTime)) {
                    this.setState({
                        isAsapOrder: true
                    });
                }
            }
        }
    }, {
        key: 'setOpenAvailableFutureDate',
        value: function setOpenAvailableFutureDate() {
            var _this4 = this;

            var datesArray = [];

            // const today = new Date();
            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();

            var dateRange = this.getScheduledAheadDays();
            var hoursRange = this.generateHoursRange(dateTime);

            if (hoursRange != null && hoursRange.length > 0) {
                datesArray.push(dateTime);
            }

            var i;
            for (i = 1; i <= dateRange; i++) {

                // const nextDate = new Date();
                // get date time based on the location
                var nextDate = _MainStore2.default.getCurrentDateTime();

                nextDate.setDate(nextDate.getDate() + i);

                var _hoursRange2 = this.generateHoursRange(nextDate);

                if (_hoursRange2 != null && _hoursRange2.length > 0) {
                    datesArray.push(nextDate);
                }
            }

            this.setState({
                futureDates: datesArray
            }, function () {
                _this4.setAvailableFutureDates();
                _this4.setScheduleDateTime();
                // this.validateScheduledDateTime();
            });
        }
    }, {
        key: 'setAvailableFutureDates',
        value: function setAvailableFutureDates() {

            var openHours = _CartStore2.default.getOnlineOrderingHours(this.state.orderType);
            var futureDates = this.state.futureDates;

            if (futureDates) {
                var orderFirstDate = new Date(futureDates[0]);
                var hoursRange = this.generateHoursRange(orderFirstDate);
                var timeStr = hoursRange[0];

                orderFirstDate = Utils.parseTime(timeStr, orderFirstDate);

                // if(!Utils.isEmpty(this.props.scheduledDate)){
                //     let orderTypeLocationOpenHours = CartStore.getOnlineOrderingHours(this.state.orderType);
                //     const isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, this.props.scheduledDate);
                //     if (isLocationOrderTypeOpen != true){
                //         this.props.updateScheduledDate(orderFirstDate );
                //         console.log("scheduled future date: " + JSON.stringify(orderFirstDate));
                //         // this.onScheduledTabClick();
                //     }else{
                //         this.props.updateScheduledDate(this.props.scheduledDate);
                //         console.log("not schedule date")
                //         // this.onScheduledTabClick();
                //     }
                // }else{
                //     this.props.updateScheduledDate(orderFirstDate);
                //     // this.onScheduledTabClick();
                // }

                this.setState({
                    selectedDateIndex: 0,
                    value12: orderFirstDate,
                    selectedTime: timeStr,
                    selectedDateTimings: Utils.getOpeningHoursOfGivenDate(openHours, orderFirstDate)
                });
            }
        }
    }, {
        key: 'setScheduleDateTime',
        value: function setScheduleDateTime() {
            var scheduledDate = this.props.scheduledDate;
            if (scheduledDate) {
                this.updateASAPScheduleTab(false);
                this.setState({
                    value12: scheduledDate,
                    selectedTime: Utils.dateToHours(scheduledDate),
                    isScheduleOrderTime: !this.props.disableSetButton ? true : false
                });

                var orderTypeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours(this.state.orderType);
                var isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, this.props.scheduledDate);

                if (isLocationOrderTypeOpen != true) {
                    this.onScheduledTabClick();
                }
            } else if (!Constants.checkRestaurantIsOpen()) {
                // if restaurant is closed then set the default schedule tab
                this.onScheduledTabClick();
            }
        }

        // validateScheduledDateTime(){
        //
        //     let scheduledDate = this.props.scheduledDate;
        //
        //     let dateStringWithTime  = Utils.formatTime(new Date(scheduledDate));
        //
        //     if (scheduledDate){
        //         let orderTypeLocationOpenHours = CartStore.getOnlineOrderingHours(this.state.orderType);
        //         const isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, scheduledDate);
        //
        //         if (isLocationOrderTypeOpen != true){
        //             this.setState({
        //                 showScheduleTimeError: false,
        //                 scheduledDateTime: scheduledDate
        //             }, () => {
        //                 // Constants.scrollToTop('scheduler-container');
        //                 this.props.showOrderSchedulerError(true);
        //                 // alert(`${this.state.orderType} order is not available at ${dateStringWithTime}.`);
        //
        //             })
        //         }else{
        //             this.setState({
        //                 showScheduleTimeError: false
        //             })
        //         }
        //     }
        // }


    }, {
        key: 'updateASAPScheduleTab',
        value: function updateASAPScheduleTab(status) {
            this.setState({
                isAsapOrder: status
            });
        }
    }, {
        key: 'setASAPDefaultTab',
        value: function setASAPDefaultTab() {
            this.state = {
                isAsapOrder: true,
                selectedTime: "",
                value12: null
                // Actions.setScheduledDate(null);
            };
        }

        // scheduleOrder = () => {

        //     if (this.state.isAsapOrder) {
        //         this.props.updateScheduledDate(null);
        //         Actions.setScheduledDate(null);
        //     } else {
        //         this.props.updateScheduledDate(this.state.value12);
        //         Actions.setScheduledDate(this.state.value12);
        //     }
        // };

        // setScheduleOrderFuture = () => {
        //     if (this.state.isAsapOrder) {
        //         this.props.updateScheduledDate(null);
        //         Actions.setScheduledDate(null);
        //     } else {
        //         this.hideScheduleTimeComp()
        //         this.props.updateScheduledDate(this.state.value12);
        //         Actions.setScheduledDate(this.state.value12);
        //     }

        // };

    }, {
        key: 'render',
        value: function render() {

            // check if restaurant is open or closed
            // if closed then disabled the ASAP button
            var asapClass = "";
            if (Constants.checkRestaurantIsOpen()) {
                asapClass = "btn-group btn-group-toggle w-50";
            } else {
                asapClass = "btn-group btn-group-toggle w-50 disabled-btn";
            }

            return _react2.default.createElement(
                'div',
                { className: 'orderScheduler', id: "scheduler-container" },
                _react2.default.createElement(
                    'h6',
                    null,
                    'When would you like your order?'
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'form-group mb-0' },
                    _react2.default.createElement(
                        _TabContainer2.default,
                        {
                            classNames: 'tab-container',
                            tabLinksClassNames: 'btn schedule-border-property custom-btn-outline-primary ft-14',
                            selected: this.isAsapOrder() ? 0 : 1,
                            activePropsState: true
                        },
                        _react2.default.createElement(
                            _TabPane2.default,
                            {
                                label: 'ASAP',
                                classNames: asapClass,
                                onTabClick: this.onAsapTabClick,
                                isHiddenDiv: false
                            },
                            _react2.default.createElement(
                                PaneContent,
                                null,
                                _react2.default.createElement(
                                    'div',
                                    { className: 'future-date-container' },
                                    _react2.default.createElement(
                                        'div',
                                        {
                                            className: 'col-lg-12 cart-box',
                                            key: 'dx'
                                        },
                                        _react2.default.createElement(
                                            'p',
                                            { className: "mb-1" },
                                            'As soon as possible'
                                        )
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            _TabPane2.default,
                            {
                                label: 'SCHEDULE',
                                classNames: 'btn-group btn-group-toggle w-50',
                                onTabClick: this.onScheduledTabClick,
                                isHiddenDiv: false
                            },
                            _react2.default.createElement(
                                PaneContent,
                                null,
                                !this.state.isAsapOrder ? _react2.default.createElement(
                                    'div',
                                    { className: "w-100 mt-2" },
                                    _react2.default.createElement(
                                        'div',
                                        { className: "col-6 d-inline-block" },
                                        _react2.default.createElement(
                                            'label',
                                            { className: "font-weight-bold" },
                                            'Select Date'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            {
                                                className: 'custom-select',
                                                value: this.state.value12 ? this.state.value12.toDateString() : "",
                                                onChange: this.handleSelectedDateChange,
                                                id: 'date-select'
                                            },
                                            this.generateFutureDates()
                                        )
                                    ),
                                    _react2.default.createElement(
                                        'div',
                                        { className: "col-6 d-inline-block" },
                                        _react2.default.createElement(
                                            'label',
                                            { className: "font-weight-bold" },
                                            'Select Time'
                                        ),
                                        _react2.default.createElement(
                                            'select',
                                            {
                                                className: 'custom-select',
                                                value: this.state.selectedTime,
                                                onChange: this.handleSelectedDateTimeChange,
                                                id: 'time-select',
                                                required: true
                                            },
                                            this.generateFutureTime()
                                        )
                                    )
                                )
                                // <div className={"cart-box"}>
                                //     <div className="dropdown-selector col-lg-12 order__Scheduler_tab">
                                //         <div className="col-md-6 col-sm-6 col-xs-6">
                                //             <label className="schedule-select-option" htmlFor="date-select">Day: </label>
                                //             <select
                                //                 className="selectpicker btn-drop-down form-control form-select"
                                //                 value={this.state.value12 ? this.state.value12.toDateString() : ""}
                                //                 onChange={this.handleSelectedDateChange}
                                //                 id="date-select"
                                //             >
                                //                 {this.generateFutureDates()}
                                //             </select>
                                //         </div>
                                //
                                //         <div className="col-md-6 col-sm-6 col-xs-6">
                                //             <label className="schedule-select-option" htmlFor="time-select">Time: </label>
                                //             <select
                                //                 className="selectpicker btn-drop-down form-control form-select"
                                //                 value={this.state.selectedTime}
                                //                 onChange={this.handleSelectedDateTimeChange}
                                //                 id="time-select"
                                //                 required
                                //             >
                                //                 {this.generateFutureTime()}
                                //             </select>
                                //         </div>
                                //     </div>
                                // </div>
                                : null
                            )
                        )
                    )
                )
            );
        }
    }]);

    return OrderScheduleScreen;
}(_react2.default.Component);

exports.default = OrderScheduleScreen;
;

var PaneContent = function PaneContent(_ref) {
    var isActive = _ref.isActive,
        children = _ref.children;


    if (!children) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: 'row' },
        children
    );
};


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/OrderScheduleScreen.jsx
// module id = 487
// module chunks = 0